<template>
  <div>
    <condition-part
      :hasDate="true"
      :hasSalPriceSeperate="true"
      :hasTradeStatusType="true"
      :hasFoodStatusType="true"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @downloadPdf="downloadPdf"
      @printPdf="printPdf"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      columns: [
        { name: "CustomerNumber" },
        { name: "CustomerName" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "Barcode" },
        { name: "Unit" },
        { name: "Qty" },
        { name: "SalPrice" },
        { name: "Total" },
      ],
      items: [],
      pagination: {},
    };
  },
  components: {
    conditionPart,
  },
  methods: {
    downloadExcel(condition) {
      this.$api.reportExcels.getCustomerFoodSale(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getCustomerFoodSale(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printCustomerFoodSale(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getCustomerFoodSale(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
